import { radiusStringToInt } from 'modules/search/helpers/radius';
import { filterToIndex } from 'modules/search/helpers/savedSearches';
import type { SearchFacet } from 'modules/search/types/SearchFacet';
import type { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import type { SearchLocation } from 'modules/search/types/SearchLocation';
import type { SearchType } from 'modules/search/types/SearchType';

import { almostSavedSearchSerializableDataStructure } from './almostSavedSearchSerializableDataStructure';

type Args = {
  query: string;
  searchFilterType: SearchType;
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
  radius: string | undefined;
  searchFacets: SearchFacet[];
};

export function getSearchPropertiesFromState({
  query,
  searchFilterType,
  filtersById,
  searchLocation,
  radius,
  searchFacets,
}: Args) {
  const { text, ...locationWithoutText } = searchLocation || {};
  return {
    filters: almostSavedSearchSerializableDataStructure({
      filtersById,
      searchFacets,
    }),
    location: {
      text,
      ...locationWithoutText,
    },
    text: query,
    radius: radiusStringToInt(radius),
    index: filterToIndex(searchFilterType),
  };
}
